<template>
  <div class="space-y-2">
    <div class="text-right">
      <ContactActions :contact="contact" />
    </div>
    <div class="group">
      <div class="flex items-center space-x-2">
        <div class="flex-1">
          <span
            v-if="typeof contact.unsubscribeRequestId === 'string'"
            class="inline-flex items-center rounded-full bg-red-100 px-2.5 py-0.5 text-xs font-medium text-red-800"
            >{{ $t('global.unsubscribed') }}</span
          >
          <h1 class="text-2xl font-bold text-gray-900">
            {{ contact.fullName }}
          </h1>
        </div>
        <div class="hidden flex-none group-hover:block">
          <EditContactName :contact-id="contactId" />
        </div>
      </div>
      <div class="text-sm font-medium text-gray-500">
        <span v-if="primaryEmailAddress">
          {{ primaryEmailAddress.address }}
        </span>
      </div>
    </div>
    <ContactDuplicatesManager :contact-id="contactId" />
  </div>
</template>

<script>
import EditContactName from './EditContactName.vue';
import ContactActions from './ContactActions.vue';
import ContactDuplicatesManager from './ContactDuplicatesManager.vue';

export default {
  components: {
    EditContactName,
    ContactActions,
    ContactDuplicatesManager,
  },
  props: {
    contactId: {
      type: String,
      required: true,
    },
  },
  computed: {
    contact() {
      return this.$store.state.entities.contacts.byId[this.contactId];
    },
    emailAddresses() {
      return (this.contact?.emailAddresses || [])
        .map((emailAddressId) => this.$store.state.entities.emailAddresses.byId[emailAddressId])
        .filter(Boolean);
    },
    primaryEmailAddress() {
      if (!this.contact?.primaryEmailAddress) {
        return null;
      }

      return this.$store.state.entities.emailAddresses.byId[this.contact.primaryEmailAddress];
    },
  },
};
</script>
